import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { news } from '../configs/news';
import { ImageComponent } from '../components/ImageModal';
import './NewsPage.scss';

export function NewsDetailPage() {
    const { slug } = useParams<{ slug: string }>();
    const item = news.find(n => n.slug === slug);

    if (!item) {
        return <div className='news__not-found'>Новость не найдена. <Link className='news__not-found-link' to='/news'>Назад к новостям</Link></div>;
    }

    return (
        <div className='news details'>
             <span className='news__item-readmore'>
                 <Link
                     to='/news'
                     className='news__item-readmore-link details'
                 >← Все новости</Link>
             </span>
            <div className='news__item details'>
                <div className='news__detail-item-wrapper'>
                    <p className='news__item-title'>{item.title}</p>
                    <span
                        className='news__item-text'
                        dangerouslySetInnerHTML={{ __html: item.text }}
                    ></span>
                </div>
                <div className='news__item-img-wrapper details'>
                    {item.img.map((src, index) => (
                        <ImageComponent
                            key={index}
                            src={require(`../assets/news/${src}`)}
                            small={{ width: '200px', height: 'auto' }}
                            big={{ width: 'auto', height: '90vh' }}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
}
